import React, { useCallback, useState, useMemo, useEffect} from 'react'
import MenuItem from '@material-ui/core/MenuItem';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Popover from '@material-ui/core/Popover';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuList from '@material-ui/core/MenuList';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { classNames } from '../functions/classNames';

const useStyles = (width) => makeStyles((theme) => ({
    label: {
        opacity: 0
    },
    titleBtn: {
        boxShadow: 'none !important',
        textTransform: 'none',
        padding: '10px 20px',
        borderRadius: 0
    },
    disabled: {
        background: `${theme.palette.white.main} !important`,
    },
    groupBtn: {
        boxShadow: 'none',
    },
    arrowBtn: {
        borderRadius: 0
    },
    popover: {
        '& .MuiPaper-root': {
            width: width || 'auto',
            borderRadius: '0' 
        }
    }
}))
const SelectComponent = ({ onChange = () => { }, title, setValue, id = '', data, customClass = '', customRootClass = '', disabled }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = useMemo(() => Boolean(anchorEl), [anchorEl]);
    const idEl = useMemo(() => open ? `popover-${id}` : undefined, [open, id]);
    const handleToggle = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        setAnchorEl(null);
    };


    const classes = useStyles(document.querySelector(`#${id}`)?.clientWidth)();
    const handleChange = useCallback((event) => {
        setAnchorEl(null);
        onChange(event.target.value);
        setValue(event.target.value);
    }, [setValue, onChange])

    useEffect(() => {
        window.addEventListener('scroll', handleClose);
       return () => window.removeEventListener('scroll', handleClose);
    }, [])

    return (
        <Box>
            <ButtonGroup onClick={handleToggle} id={id} className={classNames([classes.groupBtn, customClass])} variant="contained" color="primary" aria-describedby={idEl} aria-label="split button">
                <Button classes={{ disabled: classes.disabled, root: classNames([classes.titleBtn, customRootClass])  }} disabled={disabled}>{title}</Button>
                <Button
                    color="primary"
                    size="small"
                    className={classes.arrowBtn}
                    aria-label={ title }
                    aria-haspopup="menu" 
                >
                    <ExpandMoreIcon />
                </Button>
            </ButtonGroup>
            <Popover
                className={classes.popover}
                open={open}
                disableScrollLock={true}
                id={idEl}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                    <ClickAwayListener onClickAway={handleClose}>
                        <MenuList id="split-button-menu">
                            {data?.length
                                ? data.map((item, index) =>
                                    <MenuItem
                                        key={index}
                                        value={item.value}
                                        onClick={handleChange}
                                    >
                                        {item.title}
                                    </MenuItem>
                                )
                                : ''}
                        </MenuList>
                    </ClickAwayListener>
            </Popover>
        </Box>
    )
}


export default React.memo(SelectComponent);